import React from "react";
import { Button } from "@mui/material";

function index() {
  return (
    <>
      <div className="hm  lg:px-5 py-5  ">
        <p className="lg:px-5 text-center lg:py-5  text-white font-bold text-xl lg:pt-20">
          Enter Your Payment Details
        </p>
        <div className="lg:px-5 px-3 lg:pt-10 flex lg:flex-row flex-col lg:gap-20 gap-5 justify-center">
          <div className=" bg-gray-400 rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-40 border border-gray-100">
            <div className="lg:px-5 px-3 py-10 flex-col flex gap-5  ">
              <input
                type="text"
                placeholder="Card number MM YY CVC"
                className="border border-black p-1 rounded lg:w-80 w-56 lg:ml-0 ml-10"
              />
              <input
                type="text"
                placeholder="Account Holder Name"
                className="border border-black p-1 rounded lg:w-80 w-56 lg:ml-0 ml-10"
              />
              <input
                type="number"
                placeholder="Mobile Number"
                className="border border-black p-1 rounded lg:w-80 w-56 lg:ml-0 ml-10"
              />

              <div className="flex flex-col lg:flex-row gap-5">
                <input
                  type="text"
                  placeholder="Card "
                  className="border border-black p-1 rounded lg:w-24  w-56 lg:ml-0 ml-10"
                />

                <input
                  type="Date"
                  placeholder="Expiry "
                  className="border border-black p-1 rounded  lg:w-24  w-56 lg:ml-0 ml-10"
                />
                <input
                  type="text"
                  placeholder="Card "
                  className="border border-black p-1 rounded lg:w-24  w-56 lg:ml-0 ml-10"
                />
              </div>
            </div>
            <div className="px-10 py-5">
              <Button
                variant="contained"
                className="!w-full !rounded !font-bold"
              >
                Payment
              </Button>
            </div>
          </div>
          <div className="flex flex-col lg:gap-5 gap-2 w-72">
            <div className="flex border-white border p-2  rounded-xl">
              <input
                type="radio"
                placeholder="Credit Card"
                className="border border-black p-1 rounded"
              />
              <p className="text-white text-xl !ml-5">Credit </p>
            </div>
            <div className="flex border-white border p-2 rounded-xl">
              <input
                type="radio"
                placeholder="Debit Card"
                className="border border-black p-1 rounded"
              />
              <p className="text-white text-xl !ml-5">Debit </p>
            </div>
            <div className="flex border-white border p-2 rounded-xl">
              <input
                type="radio"
                placeholder="Cash on Delivery"
                className="border border-black p-1 rounded"
              />
              <p className="text-white text-xl !ml-5">Cash on Delivery</p>
            </div>
            <img
              src="	https://static-assets-web.flixcart.com/fk-p-linchpin-web/fk-cp-zion/img/payment-method_69e7ec.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default index;
